import React, { useEffect, useState } from "react";

import { rockGemsApi } from "../../services/rockGemsApi";
import ErrorAlert from "../common/ErrorAlert";
import LoadingBlock from "../common/LoadingBlock";
import RockGemLikeDetail from "../rock/RockGemLikeDetail";

export default function GemDetailView({ uid, category_uid, language_code = "en" }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [gem, setGem] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function run() {
      if (!uid) return;
      setLoading(true);
      setError(null);
      try {
        const data = await rockGemsApi.getGemDetail({
          uid,
          category_uid,
          language_code: language_code || "en"
        });
        if (!cancelled) setGem(data);
      } catch (e) {
        if (!cancelled) setError(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    run();
    return () => {
      cancelled = true;
    };
  }, [uid, category_uid, language_code]);

  return (
    <div>
      <ErrorAlert error={error} title="Failed to load gem detail" />
      {loading ? <LoadingBlock label="Loading gem detail..." /> : null}
      {!loading && gem ? (
        <RockGemLikeDetail
          gem={gem}
          showCrawlFields
          language_code={language_code}
        />
      ) : null}
    </div>
  );
}
